<template>
  <el-dialog
    :title="title"
    @close="close()"
    v-model="visible"
    width="60%"
    append-to-body
  >
    <div class="box">
      <div class="box-left">
        <div><el-image class="dt-image" :src="url"></el-image></div>
        <div class="xt clearfix">
          <el-image
            class="xt-image"
            @click="clickTp(item.pic_url)"
            v-for="item of urls"
            :key="item.index"
            :src="item.pic_url"
          ></el-image>
        </div>
      </div>
      <div class="box-right">
        <div class="box-right-title">{{ des }}</div>
        <div class="text-wrap">{{ describe }}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "Box",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    goods_id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      visible: false,
      url: "",
      des: "",
      describe: "",
      urls: [],
    };
  },
  // 监听
  watch: {
    dialogVisible(newValue) {
      this.visible = newValue;
      this.queryProdDetail()
    },
  },
  methods: {
    // 关闭弹窗
    close() {
      this.$emit("close", false);
    },
    // 點擊切換圖片
    clickTp(url) {
      this.url = url;
    },
        // 货品详情
    queryProdDetail() {
      console.log(this.goods_id)
      this.$api.queryProdDetail({"prod_sn":this.goods_id}).then(
        res => {
          console.log(res)
          if (res.state == 10000) {

            this.des=res.data.prod[0]["prod_des"]
            this.describe=res.data.prod[0]["intro"]
            this.url=res.data.prod_pic[0]["pic_url"]
            this.urls=res.data.prod_pic
          } else {
            this.$message.error(res.msg);
          }
        },
        () => {
          this.$message.error("请求超时");
        }
      );
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.dt-image {
  width: 680px;
  height: 480px;
}
.xt {
  height: 100px;
  width: 60%;
}
.xt-image {
  margin: 10px;
  height: 100px;
  width: 150px;
  float: left;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.1);
}
.box-right-title {
  font-size: 30px;
  padding: 20px;
  color: #474747;
  border-bottom: 1px solid #444444;
  margin-bottom: 30px;
}

.text-wrap {
  /* 核心样式：识别\n换行，合并连续空格 */
  white-space: pre-line;
  /* 可选：如果需要保留所有空格/制表符，用 white-space: pre; */
  /* white-space: pre; */
}
</style>